import { Injectable, DOCUMENT, inject } from '@angular/core';

import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable()
export class AppOverlayContainer extends OverlayContainer {
  constructor() {
    const document = inject<Document>(DOCUMENT);

    super(document);
  }

  protected override _createContainer(): void {
    const container = this._document.createElement('div');
    container.classList.add('cdk-overlay-container');
    this._document.body.appendChild(container);
    this._containerElement = container;
  }
}
